import { type ExtendedCreator } from "@forento/core/models/user"

const formLink = "https://forento.link/customer-highlight"

export type CreatorHighlightsFormSource = "banner"

/** The short link forwards query parameters to Tally, whose hidden fields prefill the matching questions. */
export function getCreatorHighlightsFormUrl(user: ExtendedCreator, source: CreatorHighlightsFormSource) {
	const url = new URL(formLink)
	url.searchParams.set("name", `${user.firstName} ${user.lastName}`.trim())
	url.searchParams.set("email", user.email)
	const domain = user.platform?.domain.landingPage ?? user.platform?.domain.platform
	if (domain) url.searchParams.set("academy", `https://${domain}`)
	url.searchParams.set("source", source)
	return url.toString()
}

export function trackCreatorHighlightsFormOpened(source: CreatorHighlightsFormSource) {
	window.posthog?.capture("creator_highlights_form_opened", { source })
}
